<template>
  <div 
    class="default-preview"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <div class="preview-content">
      <span class="element-type">{{ element.label || element.type }}</span>
      <span class="preview-message">Element preview not available</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultPreview',
  props: {
    element: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isHovered: false,
      isEditing: false
    };
  }
};
</script>

<style scoped>
.default-preview {
  width: 100%;
}

.preview-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px;
  background: #F9F9F9;
  border: 1px dashed #C4C4C4;
  border-radius: 4px;
}

.element-type {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.preview-message {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #999;
}
</style>
